import React from 'react'

export default props => (
    <div className='row' {...props}>{props.children}</div>
)